import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { addUserToUnsubscribedList } from '../../firebase/api/unsubscribed_users';
import { useActions } from '../../hooks/useActions';
import { useSelector } from '../../hooks/useSelector';

import AppLoader from '../../components/appLoader/AppLoader';

import './Unsubscribe.css'


const Unsubscribe = () => {

    const { id } = useParams()
    const [succesfullUnsub, setSuccesfullUnsub] = useState(false)
    const { loading, isAlreadyUnsub } = useSelector(state => state.unsubscribedUsers)
    const { fetchUnsubscribedUsers } = useActions()

    const email = atob(id)

    useEffect(() => {
        fetchUnsubscribedUsers(email)
    }, [email])


    const handleUnsubscribe = useCallback(
        async () => {

            const dto = {
                email: email,
            }

            addUserToUnsubscribedList(dto)
                .then(() => {
                    setSuccesfullUnsub(true)
                })
        },
    [email]
    )

    return (
        <div className='unsubscribe-page'>
            {
                loading &&
                <AppLoader />
            }
            {   !loading &&
                <>
                    {
                        isAlreadyUnsub &&
                        <span>You have already unsubscribed!</span>
                    }
                    {
                        succesfullUnsub &&
                        <span>Congratulations to succesfully unsubscribed!</span>
                    }
                    {
                        !isAlreadyUnsub &&
                        !succesfullUnsub &&
                        <button
                            disabled={isAlreadyUnsub}
                            className='unsubscribe-button'
                            onClick={handleUnsubscribe}
                        >
                            Unsubscribe
                        </button>
                    }
                </>
            }
        </div>
    )
}

export default Unsubscribe;